import { IAuditModel, ObjectId } from './base';
import { IFile } from './file';
import { IPoint, IPolygon } from './geo';

export enum AgencyType {
  EMS = 'EMS',
  FIRE = 'FIRE',
  POLICE = 'POLICE',
  EMERGENCY_MANAGEMENT = 'EMERGENCY_MANAGEMENT',
  MUNICIPAL_SERVICES = 'MUNICIPAL_SERVICES',
}

export interface IAgencyForm extends ObjectId {
  name: string;
  phoneNumber?: string;
  email?: string;
  address?: {
    address1: string;
    address2?: string;
    city: string;
    state: string;
    zipcode: string;
  };
  type: AgencyType;
  area: string;
  oriNumber: string;
  account?: {
    _id: string;
    number: string;
  };
  isEnabledJMS?: boolean;
  isEnabledComplaintPolicy?: boolean;
  isOfficeChatEnabled?: boolean;
  isEnabledCreateCaseFromCfs?: boolean;
  isEnabledCreateStandaloneCases?: boolean;
  isEnabledSkydioEmailIntegration?: boolean;
  logo?: IFile;
  code?: string;
  headerText?: string;
  headerAlignment?: 'left' | 'right' | 'center';
}

export interface IAgencyNeris {
  stationId: string;
}

export interface IAgency extends IAuditModel, Omit<IAgencyForm, 'area'> {
  neris?: IAgencyNeris;
  area: IPolygon;
  center: IPoint;
  abbreviation?: string;
  addressPrePlanType: string;
  defaultCtvCode?: string;
}
